import { ThemeEvents } from '@theme/events';

/**
 * @typedef {object} SingleItemOrderState
 * @property {boolean} hasSingleItem
 * @property {boolean} hasRegularItem
 * @property {boolean} blockCheckout
 */

/** @type {SingleItemOrderState} */
const EMPTY_STATE = {
  hasSingleItem: false,
  hasRegularItem: false,
  blockCheckout: false,
};

/**
 * @returns {SingleItemOrderState}
 */
function readState() {
  const nodes = document.querySelectorAll('[data-single-item-order-state]');
  const source = nodes.length > 0 ? nodes[nodes.length - 1] : null;

  if (source?.textContent) {
    try {
      const parsed = JSON.parse(source.textContent);
      const state = {
        hasSingleItem: Boolean(parsed?.hasSingleItem),
        hasRegularItem: Boolean(parsed?.hasRegularItem),
        blockCheckout: Boolean(parsed?.blockCheckout),
      };
      Theme.singleItemOrder = state;
      return state;
    } catch (error) {
      console.error('Failed to parse single-item order state', error);
    }
  }

  return Theme.singleItemOrder ?? EMPTY_STATE;
}

/**
 * @param {boolean} isSingleItemProduct
 * @param {SingleItemOrderState} [state]
 * @returns {boolean}
 */
function isAddToCartBlocked(isSingleItemProduct, state = readState()) {
  return isSingleItemProduct && state.hasSingleItem;
}

/**
 * @param {HTMLButtonElement} button
 * @param {boolean} blocked
 */
function setButtonBlocked(button, blocked) {
  if (blocked) {
    if (!button.disabled || button.dataset.singleItemBlocked === 'true') {
      button.disabled = true;
      button.dataset.singleItemBlocked = 'true';
    }
    return;
  }

  if (button.dataset.singleItemBlocked === 'true') {
    button.disabled = false;
    delete button.dataset.singleItemBlocked;
  }
}

function applyState() {
  const state = readState();

  document.querySelectorAll('product-form-component').forEach((form) => {
    if (!(form instanceof HTMLElement)) return;

    const isSingleItemProduct = form.dataset.singleItemProduct === 'true';
    const blocked = isAddToCartBlocked(isSingleItemProduct, state);
    form.dataset.singleItemBlocked = blocked ? 'true' : 'false';

    form
      .querySelectorAll('[ref="addToCartButton"], .quick-add__button--choose, .quick-add__button--add')
      .forEach((button) => {
        if (button instanceof HTMLButtonElement) {
          setButtonBlocked(button, blocked);
        }
      });

    const acceleratedCheckout = form.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
    if (acceleratedCheckout instanceof HTMLElement) {
      acceleratedCheckout.toggleAttribute('hidden', blocked);
    }
  });

  document.querySelectorAll('sticky-add-to-cart').forEach((element) => {
    if (!(element instanceof HTMLElement)) return;

    const isSingleItemProduct = element.dataset.singleItemProduct === 'true';
    const blocked = isAddToCartBlocked(isSingleItemProduct, state);
    element.dataset.singleItemBlocked = blocked ? 'true' : 'false';

    const button = element.querySelector('[ref="addToCartButton"]');
    if (button instanceof HTMLButtonElement) {
      setButtonBlocked(button, blocked);
    }
  });
}

document.addEventListener(ThemeEvents.cartUpdate, () => {
  setTimeout(applyState, 0);
});

document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const checkoutButton = target.closest('#checkout, .cart__checkout-button');
    if (!(checkoutButton instanceof HTMLElement)) return;
    if (!readState().blockCheckout) return;

    event.preventDefault();
    event.stopPropagation();
  },
  true
);

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form') return;
  if (!readState().blockCheckout) return;

  event.preventDefault();
});

applyState();
